export const tokenParamNameRegex = /([a-zA-Z]+Token)=/;
function extractParamName(tokenRegex) {
    const result = tokenParamNameRegex.exec(tokenRegex.source)?.[1];
    return result;
}
export const confirmAccountTokenRegex = /confirmAccountToken=([a-fA-F0-9]{16})/;
export const confirmTokenParamName = extractParamName(confirmAccountTokenRegex);
export const resetTokenRegex = /resetToken=([a-f0-9]+)/;
export const resetTokenParamName = extractParamName(resetTokenRegex);
//# sourceMappingURL=tokens.js.map